import { StudiosType } from "./studios.type";

export type UsersType = {
  id: number;
  name: string;
  head_coach: boolean;
  role_id?: number;
  job_title?: string;
  age?: number;
  password: string;
  phone?: string;
  email: string;
  gender?: string;
  date_of_birth?: string;
  profile_image?: string;
  login_type?: string;
  created_at?: Date;
  updated_at?: Date;
  user_studios: {
    user_id: number;
    studio_id: number;
    studio: StudiosType;

  }[];
}

export enum UserRoles {
  ADMIN = 1,
  TRAINER = 2,
  USER = 3,
  HEAD_COACH = 4
}